import { combineReducers } from '@reduxjs/toolkit'

import aASlice from './a-a-slice.gen'
import abrKarteSlice from './abr-karte-slice.gen'
import accountLookupSlice from './account-lookup-slice'
import actionPanel from './action-panel'
import actionsMenu from './actions-menu'
import auftragAbnahmeSlice from './auftrag-abnahme-slice.gen'
import auftragAngebotKreditorSlice from './auftrag-angebot-kreditor-slice.gen'
import auftragBuchungsPostenSlice from './auftrag-buchungs-posten-slice.gen'
import auftragGenehmigungDefinitionHistorySlice from './auftrag-genehmigung-definition-history-slice.gen'
import auftragGenehmigungKategorieSlice from './auftrag-genehmigung-kategorie-slice.gen'
import auftragHinweisSlice from './auftrag-hinweis-slice.gen'
import auftragHistorySlice from './auftrag-history-slice.gen'
import auftragMassnahmeSlice from './auftrag-massnahme-slice.gen'
import auftragMeldungSlice from './auftrag-meldung-slice.gen'
import auftragMerkmalSlice from './auftrag-merkmal-slice.gen'
import auftragMultimediaSlice from './auftrag-multimedia-slice.gen'
import auftragPositionSlice from './auftrag-position-slice.gen'
import auftragPrioSlice from './auftrag-prio-slice.gen'
import auftragRechnungSlice from './auftrag-rechnung-slice.gen'
import auftragsArtKlasseSlice from './auftrags-art-klasse-slice.gen'
import auftragsArtSlice from './auftrags-art-slice.gen'
import auftragSBriefArchivSlice from './auftrag-s-brief-archiv-slice.gen'
import auftragSicherungSlice from './auftrag-sicherung-slice.gen'
import auftragSlice from './auftrag-slice.gen'
import auftragsStatusArtSlice from './auftrags-status-art-slice.gen'
import auftragTerminModuleSlice from './auftrag-termin-module-slice.gen'
import auftragTerminSlice from './auftrag-termin-slice.gen'
import auftragVertragSlice from './auftrag-vertrag-slice.gen'
import belegAusgabeSlice from './beleg-ausgabe-slice.gen'
import btkreisflstmrelSlice from './btkreisflstmrel-slice.gen'
import btKreisSlice from './bt-kreis-slice.gen'
import buDimSlice from './bu-dim-slice.gen'
import changeFlartSlice from './change-flart-slice.gen'
import clearingFiltersSlice from './clearing-filters-slice'
import contractFlantSlice from './contract-flant-slice.gen'
import contracts from './contracts'
import copyAbrArtSlice from './copy-abr-art-slice.gen'
import copyFlartSlice from './copy-flart-slice.gen'
import cPopupSlice from './confirmation-popup-slice'
import erlSchm200010BuSlice from './erl-schm-200010-bu-slice.gen'
import esolldscSlice from './esolldsc-slice.gen'
import flantSlice from './flant-slice.gen'
import flartChangeNrSlice from './flart-change-nr-slice.gen'
import flartCopySlice from './flart-copy-slice.gen'
import flartSlice from './flart-slice.gen'
import flartTakeOverSlice from './flart-take-over-slice.gen'
import flbelBeginSlice from './flbel-begin-slice.gen'
import flbelDataSlice from './flbel-data-slice.gen'
import flbelEndSlice from './flbel-end-slice.gen'
import flbelResetEndSlice from './flbel-reset-end-slice.gen'
import flbelSlice from './flbel-slice.gen'
import flidxSlice from './flidx-slice.gen'
import flsolmfzSlice from './flsolmfz-slice.gen'
import flsolSlice from './flsol-slice.gen'
import flssoSlice from './flsso-slice.gen'
import flstmSlice from './flstm-slice.gen'
import flubeSlice from './flube-slice.gen'
import flustSlice from './flust-slice.gen'
import flvtgSlice from './flvtg-slice.gen'
import genehmigungDefinitionHistorySlice from './genehmigung-definition-history-slice.gen'
import genehmigungDefinitionSlice from './genehmigung-definition-slice.gen'
import genehmigungKategorieSlice from './genehmigung-kategorie-slice.gen'
import globalSlice from './global-slice.gen'
import gruppenDbSlice from './gruppen-db-slice.gen'
import gwMaengelStatusSlice from './gw-maengel-status-slice.gen'
import gwSicherungsArtSlice from './gw-sicherungs-art-slice.gen'
import gwSicherungsStatusSlice from './gw-sicherungs-status-slice.gen'
import issueNotes from './issue-notes'
import issues from './issues'
import issueSlice from './issue-slice.gen'
import ix1033UmlBetSubpageSlice from './1033-uml-bet-subpage-slice.gen'
import ix2000biSlice from './2000bi-slice.gen'
import ix20011Slice from './20011-slice.gen'
import ix202001 from './202001-slice.gen'
import ix2031Slice from './2031-slice.gen'
import ix2044Slice from './2044-slice.gen'
import ix2060Slice from './2060-slice.gen'
import ix2067Slice from './2067-slice.gen'
import ix2076Slice from './2076-slice.gen'
import ixPrnSrvcPrinterSlice from './prn-srvc-printer-slice.gen'
import ixprnsrvcprinterSlice from './ixprnsrvcprinter-slice.gen'
import ixPrnsrvcSlice from './prnsrvc-slice.gen'
import jobSlice from './job-slice.gen'
import ktgDimSlice from './ktg-dim-slice.gen'
import leistungsArtSlice from './leistungs-art-slice.gen'
import leistungsVerzeichnisSlice from './leistungs-verzeichnis-slice.gen'
import lieferBedingungSlice from './liefer-bedingung-slice.gen'
import lookupData from './lookup-data-slice'
import mahndatenSlice from './mahndaten-slice.gen'
import mbSlice from './mb-slice.gen'
import meldungAngebotKreditorSlice from './meldung-angebot-kreditor-slice.gen'
import meldungAngebotSlice from './meldung-angebot-slice.gen'
import meldungAuftragSlice from './meldung-auftrag-slice.gen'
import meldungHinweis3Slice from './meldung-hinweis-3-slice.gen'
import meldungHinweisSlice from './meldung-hinweis-slice.gen'
import meldungHistorySlice from './meldung-history-slice.gen'
import meldungMerkmalSlice from './meldung-merkmal-slice.gen'
import meldungMultimediaSlice from './meldung-multimedia-slice.gen'
import meldungNcremTerminSlice from './meldung-ncrem-termin-slice.gen'
import meldungPrioSlice from './meldung-prio-slice.gen'
import meldungsArtKlasseSlice from './meldungs-art-klasse-slice.gen'
import meldungsArtSlice from './meldungs-art-slice.gen'
import meldungSBriefArchivSlice from './meldung-s-brief-archiv-slice.gen'
import meldungSlice from './meldung-slice.gen'
import meldungStatusArtSlice from './meldung-status-art-slice.gen'
import meldungTerminRegelSlice from './meldung-termin-regel-slice.gen'
import meldungTerminSlice from './meldung-termin-slice.gen'
import meldungVersFallGwrkSlice from './meldung-vers-fall-gwrk-slice.gen'
import meldungVersFallSlice from './meldung-vers-fall-slice.gen'
import meldungVertragSlice from './meldung-vertrag-slice.gen'
import mkSlice from './mk-slice.gen'
import navBadgesSlice from './nav-badges-slice'
import notes from './notes-slice'
import notifications from './notifications'
import objects from './objects'
import objSlice from './obj-slice.gen'
import ownerSlice from './owner-slice.gen'
import ownSlice from './own-slice.gen'
import ownSubSlice from './own-sub-slice.gen'
import pagesSlice from './pages-slice'
import perSlice from './per-slice.gen'
import printerSetupSlice from './printer-setup-slice.gen'
import process1001Slice from './process-1001-slice.gen'
import process1003Slice from './process-1003-slice.gen'
import process1005Slice from './process-1005-slice.gen'
import process1006Slice from './process-1006-slice.gen'
import process101002ParamSlice from './process-101002-param-slice.gen'
import process101003Slice from './process-101003-slice.gen'
import process1010Slice from './process-1010-slice.gen'
import process102001Slice from './process-102001-slice.gen'
import process102002Slice from './process-102002-slice.gen'
import process102003Slice from './process-102003-slice.gen'
import process1021ParamSlice from './process-1021-param-slice.gen'
import process1022BuSperreSlice from './process-1022-bu-sperre-slice.gen'
import process1022KtoBuSperreAutoSlice from './process-1022-kto-bu-sperre-auto-slice.gen'
import process1022KtoDelSlice from './process-1022-kto-del-slice.gen'
import process1022KtoDupRefSlice from './process-1022-kto-dup-ref-slice.gen'
import process1022KtoDupSlice from './process-1022-kto-dup-slice.gen'
import process1022KtoRenameSlice from './process-1022-kto-rename-slice.gen'
import process103002Slice from './process-103002-slice.gen'
import process1033AnteileVorperiodeUebernehmenSlice from './process-1033-anteile-vorperiode-uebernehmen-slice.gen'
import process1033CopyAnteileSlice from './process-1033-copy-anteile-slice.gen'
import process1033CopyUmlSlice from './process-1033-copy-uml-slice.gen'
import process1033RegGesAnteileSlice from './process-1033-reg-ges-anteile-slice.gen'
import process1033RenameUmlSlice from './process-1033-rename-uml-slice.gen'
import process1033Slice from './process-1033-slice.gen'
import process1040Slice from './process-1040-slice.gen'
import process1061Slice from './process-1061-slice.gen'
import process107049Slice from './process-107049-slice.gen'
import process107050Slice from './process-107050-slice.gen'
import process107055Slice from './process-107055-slice.gen'
import process107101Slice from './process-107101-slice.gen'
import process107102Slice from './process-107102-slice.gen'
import process107103Slice from './process-107103-slice.gen'
import process1071041Slice from './process-1071041-slice.gen'
import process107104Slice from './process-107104-slice.gen'
import process107105Slice from './process-107105-slice.gen'
import process107108Slice from './process-107108-slice.gen'
import process107109Slice from './process-107109-slice.gen'
import process107110Slice from './process-107110-slice.gen'
import process107113Slice from './process-107113-slice.gen'
import process107115Slice from './process-107115-slice.gen'
import process107120Slice from './process-107120-slice.gen'
import process107122Slice from './process-107122-slice.gen'
import process107123Slice from './process-107123-slice.gen'
import process107128Slice from './process-107128-slice.gen'
import process107129Slice from './process-107129-slice.gen'
import process107135Slice from './process-107135-slice.gen'
import process107211Slice from './process-107211-slice.gen'
import process107232Slice from './process-107232-slice.gen'
import process1072ParamSlice from './process-1072-param-slice.gen'
import process1072ZpModulSlice from './process-1072-zp-modul-slice.gen'
import process1082Slice from './process-1082-slice.gen'
import process1084Slice from './process-1084-slice.gen'
import process1086Slice from './process-1086-slice.gen'
import process109041Slice from './process-109041-slice.gen'
import process1090Slice from './process-1090-slice.gen'
import process11722Slice from './process-11722-slice.gen'
import process11725Slice from './process-11725-slice.gen'
import process1230051Slice from './process-1230051-slice.gen'
import process1230053Slice from './process-1230053-slice.gen'
import process123010Slice from './process-123010-slice.gen'
import process129301Slice from './process-129301-slice.gen'
import process1300LetztenRestantAendernSlice from './process-1300-letzten-restant-aendern-slice.gen'
import process1300PerNrChangeSlice from './process-1300-per-nr-change-slice.gen'
import process1300Slice from './process-1300-slice.gen'
import process1300VertragsbeginnSlice from './process-1300-vertragsbeginn-slice.gen'
import process1300VertragsendeSlice from './process-1300-vertragsende-slice.gen'
import process1300VertragswechselSlice from './process-1300-vertragswechsel-slice.gen'
import process1302PersonLoeschenSlice from './process-1302-person-loeschen-slice.gen'
import process1302PersontypAendernSlice from './process-1302-persontyp-aendern-slice.gen'
import process1302Slice from './process-1302-slice.gen'
import process1302Storno1RestantSlice from './process-1302-storno-1-restant-slice.gen'
import process200010Slice from './process-200010-slice.gen'
import process200101Slice from './process-200101-slice.gen'
import process200105Slice from './process-200105-slice.gen'
import process200109Slice from './process-200109-slice.gen'
import process200120Slice from './process-200120-slice.gen'
import process200120SuSaSkA4Slice from './process-200120-su-sa-sk-a-4-slice.gen'
import process200120SuSaSkAbschlussSlice from './process-200120-su-sa-sk-abschluss-slice.gen'
import process200120SuSaSkSoBuPeriSlice from './process-200120-su-sa-sk-so-bu-peri-slice.gen'
import process200140Slice from './process-200140-slice.gen'
import process2003Slice from './process-2003-slice.gen'
import process201004Slice from './process-201004-slice.gen'
import process201052Slice from './process-201052-slice.gen'
import process2011Slice from './process-2011-slice.gen'
import process2013Slice from './process-2013-slice.gen'
import process2014Slice from './process-2014-slice.gen'
import process2016Slice from './process-2016-slice.gen'
import process202001Slice from './process-202001-slice.gen'
import process2025Slice from './process-2025-slice.gen'
import process2031Slice from './process-2031-slice.gen'
import process2035ParamSlice from './process-2035-param-slice.gen'
import process204005Slice from './process-204005-slice.gen'
import process204006Slice from './process-204006-slice.gen'
import process20401Slice from './process-20401-slice.gen'
import process204031Slice from './process-204031-slice.gen'
import process204402Slice from './process-204402-slice.gen'
import process2044Slice from './process-2044-slice.gen'
import process2049ParamSlice from './process-2049-param-slice.gen'
import process2051Slice from './process-2051-slice.gen'
import process2052Slice from './process-2052-slice.gen'
import process2053Slice from './process-2053-slice.gen'
import process2061Slice from './process-2061-slice.gen'
import process206201Slice from './process-206201-slice.gen'
import process2063Slice from './process-2063-slice.gen'
import process206701ParamSlice from './process-206701-param-slice.gen'
import process206702ParamSlice from './process-206702-param-slice.gen'
import process2072Slice from './process-2072-slice.gen'
import process2073ParamSlice from './process-2073-param-slice.gen'
import process2074Slice from './process-2074-slice.gen'
import process2075Slice from './process-2075-slice.gen'
import process2076Slice from './process-2076-slice.gen'
import process211101Slice from './process-211101-slice.gen'
import process2113Slice from './process-2113-slice.gen'
import process2123Slice from './process-2123-slice.gen'
import process2124Slice from './process-2124-slice.gen'
import process22001Slice from './process-22001-slice.gen'
import process22002Slice from './process-22002-slice.gen'
import process2300ParamSlice from './process-2300-param-slice.gen'
import process240001ProDruckVglSlice from './process-240001-pro-druck-vgl-slice.gen'
import process240001Slice from './process-240001-slice.gen'
import process240007ParamSlice from './process-240007-param-slice.gen'
import process3010ParamSlice from './process-3010-param-slice.gen'
import process3025Slice from './process-3025-slice.gen'
import process3026Slice from './process-3026-slice.gen'
import process304002Slice from './process-304002-slice.gen'
import process304003Slice from './process-304003-slice.gen'
import process304004Slice from './process-304004-slice.gen'
import process304005Slice from './process-304005-slice.gen'
import process304006Slice from './process-304006-slice.gen'
import process304007Slice from './process-304007-slice.gen'
import process304011Slice from './process-304011-slice.gen'
import process304012Slice from './process-304012-slice.gen'
import process3057DruckSlice from './process-3057-druck-slice.gen'
import process3057KontrolleSlice from './process-3057-kontrolle-slice.gen'
import process3057SaveParamSlice from './process-3057-save-param-slice.gen'
import process3057VzEintragenSlice from './process-3057-vz-eintragen-slice.gen'
import process404002Slice from './process-404002-slice.gen'
import process404011Slice from './process-404011-slice.gen'
import process404050ParamSlice from './process-404050-param-slice.gen'
import process404051ParamSlice from './process-404051-param-slice.gen'
import process404052ParamSlice from './process-404052-param-slice.gen'
import process404052ZpModulSlice from './process-404052-zp-modul-slice.gen'
import process404053ParamSlice from './process-404053-param-slice.gen'
import process40600Slice from './process-40600-slice.gen'
import process40604Slice from './process-40604-slice.gen'
import process40606Slice from './process-40606-slice.gen'
import process6020BerechnungSlice from './process-6020-berechnung-slice.gen'
import process6020BuchenSlice from './process-6020-buchen-slice.gen'
import process6020ListeSlice from './process-6020-liste-slice.gen'
import process6020Slice from './process-6020-slice.gen'
import processBisonBoxExportSlice from './process-bison-box-export-slice.gen'
import processDatevParamSlice from './process-datev-param-slice.gen'
import processDmsBelegausgabeParamInterfaceSlice from './process-dms-belegausgabe-param-interface-slice.gen'
import processHypothekReportParamSlice from './process-hypothek-report-param-slice.gen'
import processIndexSlice from './process-index-slice.gen'
import processIntrealParamSlice from './process-intreal-param-slice.gen'
import processIxDiamantBuExportSlice from './process-diamant-bu-export-slice.gen'
import processIxHansaInvestBuExportSlice from './process-hansa-invest-bu-export-slice.gen'
import processIxHansaInvestStdBuExportSlice from './process-hansa-invest-std-bu-export-slice.gen'
import processIxVblKgvBuExportSlice from './process-vbl-kgv-bu-export-slice.gen'
import processKe311271Slice from './process-ke-311271-slice.gen'
import processKx0224SapBuExportSlice from './process-kx-0224-sap-bu-export-slice.gen'
import processKx10015BuExportSlice from './process-kx-10015-bu-export-slice.gen'
import processKx3124qexParamSlice from './process-kx-3124qex-param-slice.gen'
import processKxBnpSapBuExportSlice from './process-kx-bnp-sap-bu-export-slice.gen'
import processKxBuUserInfoExportSlice from './process-kx-bu-user-info-export-slice.gen'
import processKxDiamantAlsterdorfBuExpSlice from './process-kx-diamant-alsterdorf-bu-exp-slice.gen'
import processKxDiamantCureusBuExportSlice from './process-kx-diamant-cureus-bu-export-slice.gen'
import processKxDiamantMLImmoBuExportSlice from './process-kx-diamant-ml-immo-bu-export-slice.gen'
import processKxLvmSapBuExportSlice from './process-kx-lvm-sap-bu-export-slice.gen'
import processPrinterSetupParamInterfaceSlice from './process-printer-setup-param-interface-slice.gen'
import processr201052Slice from './processr-201052-slice.gen'
import processrIndexSlice from './processr-index-slice.gen'
import processSaveAutoZustellungParamSlice from './process-save-auto-zustellung-param-slice.gen'
import processStdBuExportSlice from './process-std-bu-export-slice.gen'
import processTrassetsExportSlice from './process-trassets-export-slice.gen'
import processTrinityExportSlice from './process-trinity-export-slice.gen'
import processVblExportParamSlice from './process-vbl-export-param-slice.gen'
import rechnungeingangsbuchSlice from './rechnungeingangsbuch-slice.gen'
import report1022Slice from './report-1022-slice.gen'
import report107106Slice from './report-107106-slice.gen'
import report1071Slice from './report-1071-slice.gen'
import report200084Slice from './report-200084-slice.gen'
import report200085Slice from './report-200085-slice.gen'
import report201051Slice from './report-201051-slice.gen'
import report2010Slice from './report-2010-slice.gen'
import report206202VerprobungSlice from './report-206202-verprobung-slice.gen'
import report206202VSkAbstimmungSlice from './report-206202-v-sk-abstimmung-slice.gen'
import report2400KtoAuszug from './report-2400-kto-auszug-slice.gen'
import report2400KtoAuszugSlice from './report-2400-kto-auszug-slice.gen'
import reporters from './reporters'
import reportParERechnungReadySlice from './report-par-e-rechnung-ready-slice.gen'
import revenueRentLimitSlice from './flukl-slice.gen'
import RevenueRentLimitSlice from './revenue-rent-limit-slice.gen'
import rights from './rights'
import schemas from './schemas'
import sollstellungSimulationSlice from './sollstellung-simulation-slice.gen'
import sollstellungSlice from './sollstellung-slice.gen'
import spotlight from './spotlight'
import statementFilters from './statement-filters-slice'
import tmkSlice from './tmk-slice.gen'
import toAuftragSlice from './to-auftrag-slice.gen'
import toDefSlice from './to-def-slice.gen'
import toDefTOHistorySlice from './to-def-to-history-slice.gen'
import toDefTOMerkmalDefSlice from './to-def-to-merkmal-def-slice.gen'
import toGesundheitsamtSlice from './to-gesundheitsamt-slice.gen'
import toHerstellerSlice from './to-hersteller-slice.gen'
import toHistorySlice from './to-history-slice.gen'
import toMeldungSlice from './to-meldung-slice.gen'
import toMerkmalSlice from './to-merkmal-slice.gen'
import toMultimediaSlice from './to-multimedia-slice.gen'
import toPruefungsartSlice from './to-pruefungsart-slice.gen'
import toPruefungsartTOHistorySlice from './to-pruefungsart-to-history-slice.gen'
import toPruefZyklusSlice from './to-pruef-zyklus-slice.gen'
import toRechtsgrundlagenSlice from './to-rechtsgrundlagen-slice.gen'
import toSbriefArchivSlice from './to-sbrief-archiv-slice.gen'
import toSchluesselAusgabeSlice from './to-schluessel-ausgabe-slice.gen'
import toSlice from './to-slice.gen'
import toTerminSlice from './to-termin-slice.gen'
import toVertragSlice from './to-vertrag-slice.gen'
import toWartungsHistorySlice from './to-wartungs-history-slice.gen'
import toWartZyklusSlice from './to-wart-zyklus-slice.gen'
import ui from './ui'
import umlSlice from './uml-slice.gen'
import vtgihbetSlice from './vtgihbet-slice.gen'
import vtgkschutzSlice from './vtgkschutz-slice.gen'
import xsp2048Slice from './xsp-2048-slice.gen'
import xspgetzlgtlrzSlice from './xspgetzlgtlrz-slice.gen'
import zahlungsBedingungSlice from './zahlungs-bedingung-slice.gen'

const rootReducer = combineReducers({
    aASlice,
    abrKarteSlice,
    accountLookupSlice,
    actionPanel,
    actionsMenu,
    auftragAbnahmeSlice,
    auftragAngebotKreditorSlice,
    auftragBuchungsPostenSlice,
    auftragGenehmigungDefinitionHistorySlice,
    auftragGenehmigungKategorieSlice,
    auftragHinweisSlice,
    auftragHistorySlice,
    auftragMassnahmeSlice,
    auftragMeldungSlice,
    auftragMerkmalSlice,
    auftragMultimediaSlice,
    auftragPositionSlice,
    auftragPrioSlice,
    auftragRechnungSlice,
    auftragsArtKlasseSlice,
    auftragsArtSlice,
    auftragSBriefArchivSlice,
    auftragSicherungSlice,
    auftragSlice,
    auftragsStatusArtSlice,
    auftragTerminModuleSlice,
    auftragTerminSlice,
    auftragVertragSlice,
    belegAusgabeSlice,
    btkreisflstmrelSlice,
    btKreisSlice,
    buDimSlice,
    changeFlartSlice,
    clearingFiltersSlice,
    contractFlantSlice,
    contracts,
    copyAbrArtSlice,
    copyFlartSlice,
    cPopupSlice,
    erlSchm200010BuSlice,
    esolldscSlice,
    flantSlice,
    flartChangeNrSlice,
    flartCopySlice,
    flartSlice,
    flartTakeOverSlice,
    flbelBeginSlice,
    flbelDataSlice,
    flbelEndSlice,
    flbelResetEndSlice,
    flbelSlice,
    flidxSlice,
    flsolmfzSlice,
    flsolSlice,
    flssoSlice,
    flstmSlice,
    flubeSlice,
    flustSlice,
    flvtgSlice,
    genehmigungDefinitionHistorySlice,
    genehmigungDefinitionSlice,
    genehmigungKategorieSlice,
    globalSlice,
    gruppenDbSlice,
    gwMaengelStatusSlice,
    gwSicherungsArtSlice,
    gwSicherungsStatusSlice,
    issueNotes,
    issues,
    issueSlice,
    ix1033UmlBetSubpageSlice,
    ix2000biSlice,
    ix20011Slice,
    ix202001,
    ix2031Slice,
    ix2044Slice,
    ix2060Slice,
    ix2067Slice,
    ix2076Slice,
    ixPrnSrvcPrinterSlice,
    ixprnsrvcprinterSlice,
    ixPrnsrvcSlice,
    jobSlice,
    ktgDimSlice,
    leistungsArtSlice,
    leistungsVerzeichnisSlice,
    lieferBedingungSlice,
    lookupData,
    mahndatenSlice,
    mbSlice,
    meldungAngebotKreditorSlice,
    meldungAngebotSlice,
    meldungAuftragSlice,
    meldungHinweis3Slice,
    meldungHinweisSlice,
    meldungHistorySlice,
    meldungMerkmalSlice,
    meldungMultimediaSlice,
    meldungNcremTerminSlice,
    meldungPrioSlice,
    meldungsArtKlasseSlice,
    meldungsArtSlice,
    meldungSBriefArchivSlice,
    meldungSlice,
    meldungStatusArtSlice,
    meldungTerminRegelSlice,
    meldungTerminSlice,
    meldungVersFallGwrkSlice,
    meldungVersFallSlice,
    meldungVertragSlice,
    mkSlice,
    navBadgesSlice,
    notes,
    notifications,
    objects,
    objSlice,
    ownerSlice,
    ownSlice,
    ownSubSlice,
    pagesSlice,
    perSlice,
    printerSetupSlice,
    process1001Slice,
    process1003Slice,
    process1005Slice,
    process1006Slice,
    process101002ParamSlice,
    process101003Slice,
    process1010Slice,
    process102001Slice,
    process102002Slice,
    process102003Slice,
    process1021ParamSlice,
    process1022BuSperreSlice,
    process1022KtoBuSperreAutoSlice,
    process1022KtoDelSlice,
    process1022KtoDupRefSlice,
    process1022KtoDupSlice,
    process1022KtoRenameSlice,
    process103002Slice,
    process1033AnteileVorperiodeUebernehmenSlice,
    process1033CopyAnteileSlice,
    process1033CopyUmlSlice,
    process1033RegGesAnteileSlice,
    process1033RenameUmlSlice,
    process1033Slice,
    process1040Slice,
    process1061Slice,
    process107049Slice,
    process107050Slice,
    process107055Slice,
    process107101Slice,
    process107102Slice,
    process107103Slice,
    process1071041Slice,
    process107104Slice,
    process107105Slice,
    process107108Slice,
    process107109Slice,
    process107110Slice,
    process107113Slice,
    process107115Slice,
    process107120Slice,
    process107122Slice,
    process107123Slice,
    process107128Slice,
    process107129Slice,
    process107135Slice,
    process107211Slice,
    process107232Slice,
    process1072ParamSlice,
    process1072ZpModulSlice,
    process1082Slice,
    process1084Slice,
    process1086Slice,
    process109041Slice,
    process1090Slice,
    process11722Slice,
    process11725Slice,
    process1230051Slice,
    process1230053Slice,
    process123010Slice,
    process129301Slice,
    process1300LetztenRestantAendernSlice,
    process1300PerNrChangeSlice,
    process1300Slice,
    process1300VertragsbeginnSlice,
    process1300VertragsendeSlice,
    process1300VertragswechselSlice,
    process1302PersonLoeschenSlice,
    process1302PersontypAendernSlice,
    process1302Slice,
    process1302Storno1RestantSlice,
    process200010Slice,
    process200101Slice,
    process200105Slice,
    process200109Slice,
    process200120Slice,
    process200120SuSaSkA4Slice,
    process200120SuSaSkAbschlussSlice,
    process200120SuSaSkSoBuPeriSlice,
    process200140Slice,
    process2003Slice,
    process201004Slice,
    process201052Slice,
    process2011Slice,
    process2013Slice,
    process2014Slice,
    process2016Slice,
    process202001Slice,
    process2025Slice,
    process2031Slice,
    process2035ParamSlice,
    process204005Slice,
    process204006Slice,
    process20401Slice,
    process204031Slice,
    process204402Slice,
    process2044Slice,
    process2049ParamSlice,
    process2051Slice,
    process2052Slice,
    process2053Slice,
    process2061Slice,
    process206201Slice,
    process2063Slice,
    process206701ParamSlice,
    process206702ParamSlice,
    process2072Slice,
    process2073ParamSlice,
    process2074Slice,
    process2075Slice,
    process2076Slice,
    process211101Slice,
    process2113Slice,
    process2123Slice,
    process2124Slice,
    process22001Slice,
    process22002Slice,
    process2300ParamSlice,
    process240001ProDruckVglSlice,
    process240001Slice,
    process240007ParamSlice,
    process3010ParamSlice,
    process3025Slice,
    process3026Slice,
    process304002Slice,
    process304003Slice,
    process304004Slice,
    process304005Slice,
    process304006Slice,
    process304007Slice,
    process304011Slice,
    process304012Slice,
    process3057DruckSlice,
    process3057KontrolleSlice,
    process3057SaveParamSlice,
    process3057VzEintragenSlice,
    process404002Slice,
    process404011Slice,
    process404050ParamSlice,
    process404051ParamSlice,
    process404052ParamSlice,
    process404052ZpModulSlice,
    process404053ParamSlice,
    process40600Slice,
    process40604Slice,
    process40606Slice,
    process6020BerechnungSlice,
    process6020BuchenSlice,
    process6020ListeSlice,
    process6020Slice,
    processBisonBoxExportSlice,
    processDatevParamSlice,
    processDmsBelegausgabeParamInterfaceSlice,
    processHypothekReportParamSlice,
    processIndexSlice,
    processIntrealParamSlice,
    processIxDiamantBuExportSlice,
    processIxHansaInvestBuExportSlice,
    processIxHansaInvestStdBuExportSlice,
    processIxVblKgvBuExportSlice,
    processKe311271Slice,
    processKx0224SapBuExportSlice,
    processKx10015BuExportSlice,
    processKx3124qexParamSlice,
    processKxBnpSapBuExportSlice,
    processKxBuUserInfoExportSlice,
    processKxDiamantAlsterdorfBuExpSlice,
    processKxDiamantCureusBuExportSlice,
    processKxDiamantMLImmoBuExportSlice,
    processKxLvmSapBuExportSlice,
    processPrinterSetupParamInterfaceSlice,
    processr201052Slice,
    processrIndexSlice,
    processSaveAutoZustellungParamSlice,
    processStdBuExportSlice,
    processTrassetsExportSlice,
    processTrinityExportSlice,
    processVblExportParamSlice,
    rechnungeingangsbuchSlice,
    report1022Slice,
    report107106Slice,
    report1071Slice,
    report200084Slice,
    report200085Slice,
    report201051Slice,
    report2010Slice,
    report206202VerprobungSlice,
    report206202VSkAbstimmungSlice,
    report2400KtoAuszug,
    report2400KtoAuszugSlice,
    reporters,
    reportParERechnungReadySlice,
    revenueRentLimitSlice,
    RevenueRentLimitSlice,
    rights,
    schemas,
    sollstellungSimulationSlice,
    sollstellungSlice,
    spotlight,
    statementFilters,
    tmkSlice,
    toAuftragSlice,
    toDefSlice,
    toDefTOHistorySlice,
    toDefTOMerkmalDefSlice,
    toGesundheitsamtSlice,
    toHerstellerSlice,
    toHistorySlice,
    toMeldungSlice,
    toMerkmalSlice,
    toMultimediaSlice,
    toPruefungsartSlice,
    toPruefungsartTOHistorySlice,
    toPruefZyklusSlice,
    toRechtsgrundlagenSlice,
    toSbriefArchivSlice,
    toSchluesselAusgabeSlice,
    toSlice,
    toTerminSlice,
    toVertragSlice,
    toWartungsHistorySlice,
    toWartZyklusSlice,
    ui,
    umlSlice,
    vtgihbetSlice,
    vtgkschutzSlice,
    xsp2048Slice,
    xspgetzlgtlrzSlice,
    zahlungsBedingungSlice,
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
